var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8148 77.533L39.4666 40.8876C39.8937 40.4606 39.8937 39.7719 39.4666 39.3448L2.8148 2.70335C2.12602 2.01469 0.952393 2.5033 0.952393 3.47281V76.7597C0.952393 77.733 2.12602 78.2178 2.8148 77.5291V77.533Z",
    fill: "#712EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0092 40.8915L77.661 77.5368C78.3498 78.2255 79.5234 77.7369 79.5234 76.7674V3.47668C79.5234 2.50332 78.3498 2.01856 77.661 2.70722L41.0092 39.3526C40.5821 39.7796 40.5821 40.4683 41.0092 40.8953V40.8915Z",
    fill: "#712EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsIcon2);
export default __webpack_public_path__ + "static/media/BSIcon2.e7ba61d9277871cbd0aa85533fdac192.svg";
export { ForwardRef as ReactComponent };